import React from 'react';
import { Box } from '@mui/material';

interface AudioWaveformProps {
  isPlaying: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const AudioWaveform: React.FC<AudioWaveformProps> = ({ 
  isPlaying, 
  size = 'small', 
  color = 'currentColor' 
}) => {
  const barCount = 4;
  const sizeMap = {
    small: { width: 2, maxHeight: 8, gap: 1 },
    medium: { width: 3, maxHeight: 12, gap: 2 },
    large: { width: 4, maxHeight: 16, gap: 2 }
  };

  const { width, maxHeight, gap } = sizeMap[size];

  if (!isPlaying) {
    return null;
  }

  return (
    <Box
      className="audio-waveform"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: `${gap}px`,
        marginRight: 1,
      }}
    >
      {Array.from({ length: barCount }).map((_, index) => (
        <Box
          key={index}
          className="bar"
          sx={{
            width: `${width}px`,
            height: `${maxHeight * 0.3}px`,
            backgroundColor: color,
            borderRadius: '2px',
            animation: isPlaying ? 'waveform 1.2s ease-in-out infinite' : 'none',
            animationDelay: `${index * 0.1}s`,
            '@keyframes waveform': {
              '0%, 100%': { 
                height: `${maxHeight * 0.3}px`, 
                opacity: 0.5 
              },
              '50%': { 
                height: `${maxHeight}px`, 
                opacity: 1 
              }
            }
          }}
        />
      ))}
    </Box>
  );
};

export default AudioWaveform;

export {};
